
import { Mapper } from "../../../../base/utils/mapper";
import { PendingInvoiceReportModel } from "../../../../domain/models/configuration/pending-invoice-report.model";
import { PendingInvoiceReportEntity } from "../entities/pending-invoice-report.entity";
        
        export class PendingInvoiceReportImplementationRepositoryMapper extends Mapper<PendingInvoiceReportEntity, PendingInvoiceReportModel>{
            mapFrom(param:  PendingInvoiceReportEntity):  PendingInvoiceReportModel{ 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  PendingInvoiceReportModel    ):  PendingInvoiceReportEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }